import React from "react";
import { StyleSheetManager, ThemeProvider } from "styled-components";
import { GlobalStyles } from "./GlobalStyles";
import { theme } from "./theme";
import { BrowserRouter as Router } from "react-router-dom";
import ContextProvider from "./context/ContextProvider";
import AnimatedRoutes from "./components/AnimatedRoutes/AnimatedRoutes";
import UploadProgressModal from "./components/UploadProgressModal";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { defaultQueryOptions } from "@config/reactQueryConfig";
import { Provider as ReduxProvider } from "react-redux";
import { persistor, store } from "@app-redux/store";
import { PersistGate } from "redux-persist/integration/react";
import isPropValid from "@emotion/is-prop-valid";

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
});

const App = (): React.JSX.Element => {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <ContextProvider>
            <ThemeProvider theme={theme}>
              <StyleSheetManager
                shouldForwardProp={(prop) => isPropValid(prop)}
              >
                <GlobalStyles />
                <Router>
                  <AnimatedRoutes />
                  <UploadProgressModal />
                </Router>
              </StyleSheetManager>
            </ThemeProvider>
          </ContextProvider>
        </QueryClientProvider>
      </PersistGate>
    </ReduxProvider>
  );
};

export default App;
